/* Protean LDN — behaviour for the new sections only (What's Inside carousels
   + Newsletter Perks auto-scroller). Fully independent of the existing
   custom_liquid <script> block; does not touch or redefine anything there. */

(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 860px)';
  var mq = window.matchMedia(MOBILE_QUERY);

  /* ------------------------------------------------------------------
     Ingredient carousels
     ------------------------------------------------------------------ */

  Array.prototype.forEach.call(
    document.querySelectorAll('[data-carousel]'),
    function (carousel) {
      var frames = carousel.querySelectorAll('.pw-carousel-frame');
      var label = document.getElementById(carousel.dataset.carouselLabel);
      var index = 0;

      function render() {
        Array.prototype.forEach.call(frames, function (frame, i) {
          frame.classList.toggle('is-active', i === index);
        });
        if (label) label.textContent = frames[index].dataset.label;
      }

      function step(delta) {
        index = (index + delta + frames.length) % frames.length;
        render();
      }

      carousel.addEventListener('click', function () { step(1); });

      var prevBtn = carousel.querySelector('.pw-carousel-nav-prev');
      var nextBtn = carousel.querySelector('.pw-carousel-nav-next');

      if (prevBtn) {
        prevBtn.addEventListener('click', function (event) {
          event.stopPropagation();
          step(-1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (event) {
          event.stopPropagation();
          step(1);
        });
      }

      render();
    }
  );

  /* ------------------------------------------------------------------
     Newsletter perks — auto-advancing horizontal scroller.
     ------------------------------------------------------------------ */

  var perkScroll = document.getElementById('pw-newsletter-scroll');

  if (perkScroll) {
    var perkIndex = 0;
    var perkTimer = null;
    var perkCount = perkScroll.children.length;

    var advancePerks = function () {
      perkIndex = (perkIndex + 1) % perkCount;

      if (perkIndex === 0) {
        perkScroll.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }

      var card = perkScroll.children[perkIndex];
      if (!card) return;

      var target;
      if (mq.matches) {
        target = card.offsetLeft - (perkScroll.clientWidth - card.clientWidth) / 2;
      } else {
        target =
          card.offsetLeft -
          parseFloat(window.getComputedStyle(perkScroll).paddingLeft || 0);
      }
      perkScroll.scrollTo({ left: target, behavior: 'smooth' });
    };

    var startPerks = function () {
      if (perkTimer) return;
      perkTimer = window.setInterval(advancePerks, 3200);
    };

    var stopPerks = function () {
      window.clearInterval(perkTimer);
      perkTimer = null;
    };

    perkScroll.addEventListener('mouseenter', stopPerks);
    perkScroll.addEventListener('mouseleave', startPerks);
    perkScroll.addEventListener('focusin', stopPerks);
    perkScroll.addEventListener('touchstart', stopPerks, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopPerks();
      else startPerks();
    });

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      startPerks();
    }
  }
})();
